import { ServicePlan } from "../_types/serviceplan";
import { IFetchData } from "../_types/post";
import { APIGet } from "./http";


export const GetPlans = async (locationId: number): Promise<ServicePlan[]> => {
    let toReturn: ServicePlan[] = [];

    let request: IFetchData = {
        relay_to: `/location/getplans/${locationId}`,
        method: "GET",
        authorize: true,
        service: "ewapi",
        refresh: false
    };

    toReturn = await APIGet(request) || [];
    
    return toReturn;

}

export const GetPlansWithCodeCount = async (locationId: number): Promise<ServicePlan[]> => {
    let toReturn: ServicePlan[] = [];

    let request: IFetchData = {
        relay_to: `/location/getplanswithcodecount/${locationId}`,
        method: "GET",
        authorize: true,
        service: "ewapi",
        refresh: false
    };

    toReturn = await APIGet(request) || [];
    
    return toReturn;
}